import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "../reducers";
import * as Sentry from "@sentry/react";
// Logger only used in dev env for trace
// import logger from "redux-logger";

/**
 * Redux store
 */

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	// Optionally pass options
	// For example, to set the name of the action property:
	// action: 'action',
	// state: 'state',
	actionTransformer: (action) => {
		if (action.type === "@@redux-form/INITIALIZE") {
			return null;
		}

		if (action.type === "@@redux-form/DESTROY") {
			// Do not log form destroy actions
			return null;
		}
		if (action.type === "@@redux-form/REGISTER_FIELD") {
			// Do not log form register field actions
			return null;
		}
		return action;
	},
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
	reducers,
	// composeEnhancers(applyMiddleware(thunk, logger))
	composeEnhancers(applyMiddleware(thunk), sentryReduxEnhancer)
);

export default store;
